import React from "react";

const Food = () => {
    return (
        <div>
            <h2>Food</h2>
        </div>
    )
}

export default Food